<style lang="less">
  @import "./About.less";
</style>

<template>
  <div class="about">
    <!--第一部分-->
    <div class="about-banner">
      <!--<h3>无需下载，关注即可使用</h3>-->
      <img src="../../../assets/images/about/img_about_logo.png" alt="">
      <h3>{{customerName || '途云'}}</h3>
      <!--<h4><span></span></h4>-->
      <p>使用云服务，爱车更简单</p>
    </div>

    <div class="about-con">
      <!--第二部分-->
      <h3><span>关于{{customerName || '我们'}}</span></h3>
      <p>
        {{customerName || '我们'}}，云时代车辆安全的领航者！客户通过此平台来绑定相应的设备，就可轻松掌握车辆的动态，如查询车辆位置，回看车辆行驶轨迹等贴心服务。为您打造轻松安全的行车之旅！
      </p>
      <!--第三部分-->
      <h3><span>功能介绍</span></h3>
      <img src="../../../assets/images/home/ic_bound.png" alt="">
      <h4>绑定设备</h4>
      <p>
        通过微信平台{{customerName}}绑定您的设备，就可以通过微信平台查询设备所在的位置，还有移动的轨迹等信息！您可以绑定多台设备，让你可以同时获取信息！
      </p>
      <img src="../../../assets/images/home/ic_position_server.png" alt="">
      <h4>位置服务</h4>
      <p>
        可以查看您当前设备的位置，如果设备处于离线状态，则显示最后一次在线时的位置！
      </p>
      <!--<img src="../../../assets/images/about/phoneBinding.png" alt="">-->
      <!--<h4>轨迹服务</h4>-->
      <!--<p>-->
      <!--通过此功能，可查看一天内车辆的行驶轨迹，车辆不在身边对它也完全了如指掌。-->
      <!--</p>-->
      <img src="../../../assets/images/home/ic_dev_center.png" alt="">
      <h4>设备中心</h4>
      <p>
        选择一台设备，您可以进行常用设置（设置手机号码，设置备注，防盗开启，震动灵敏度设置）；还可以进行多台设备的绑定（您可以进行绑定设备的增减）
      </p>
      <img src="../../../assets/images/home/ic_take_picture.png" alt="">
      <h4>实时拍照/视频</h4>
      <p>
        通过前后摄像头实时拍照和摄像，第一时间获取图片和视频，了解你爱车的行车环境和停车情况。
      </p>
      <img src="../../../assets/images/home/ic_album.png" alt="">
      <h4>防盗报警</h4>
      <p>
        当你爱车停车熄火后，{{customerName || '我们'}}依然为你爱车进行实时安全监测。一旦发生车辆震动，你将第一时间收到震动报警通知，并立即获取你爱车的现场位置和图片视频信息。
      </p>
      <!--<img src="../../../assets/images/about/phoneBinding.png" alt="">-->
      <!--<h4>预约导航</h4>-->
      <!--<p>-->
      <!--通过{{customerName || '该平台'}}可以远程预约导航位置。当你进入爱车就能根据下发的导航信息，直奔目的地。-->
      <!--</p>-->
      <!--<img src="../../../assets/images/about/phoneBinding.png" alt="">-->
      <!--<h4>接人服务</h4>-->
      <!--<p>-->
      <!--有时候你不清楚要接的好友的具体位置，那也不用愁。发送接人服务到你好友的微信，他会在地图上向你下达精确导航位置。通过该页面他也能时刻获取你车辆的行驶情况。-->
      <!--</p>-->
      <!--<img src="../../../assets/images/about/phoneBinding.png" alt="">-->
      <!--<h4>好友指路</h4>-->
      <!--<p>-->
      <!--你不知道目的地具体位置也没关系，那就求助好友吧。发送好友指路到你好友微信，让他在地图上给你精准定位。-->
      <!--</p>-->
      <!-- <img src="../../../assets/images/home/ic_send_audio.png" alt="">
      <h4>千里传音</h4>
      <p>
        有什么话想给车辆上的朋友说?打开千里传音，输入你想说的话，点击发送。
      </p> -->
    </div>
  </div>
</template>

<script>
import About from './About.js'
export default {
  ...About
}
</script>
